import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import TopupProduct from "../../entities/productOrder/topup/TopupProduct";
import { ProductService } from "../../service/topup/ProductService";

class TopupProductStore {

    public topupProducts: TopupProduct[];
    public products: TopupProduct[];
    public filter?: string;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore) {
        this.topupProducts = [];
        this.commonStore = commonStore;
        this.products = [];
        makeObservable(this, {
            topupProducts: observable,
            isEmpty: computed,
            products: observable
        });
    }

    get isEmpty(): boolean {
        return this.products.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async search() {
        await this.getElements();
    }

    @action
    public async getElements(): Promise<void> {
        this.commonStore.setLoading();
        const response = await ProductService.getAll();
        console.log("response", response);
        if (response.success) {
            runInAction(() => {
                this.products = response.data || [];
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default TopupProductStore;